import { AlertTriangle } from 'lucide-react';

interface StalenessIndicatorProps {
  isStale: boolean;
  label?: string;
  onRefresh?: () => void;
}

export function StalenessIndicator({ isStale, label, onRefresh }: StalenessIndicatorProps) {
  if (!isStale) return null;

  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-sm">
      <AlertTriangle size={14} className="text-amber-500 shrink-0" />
      <span className="text-amber-700">
        {label || 'Brief has been updated since this was generated.'}
      </span>
      {onRefresh && (
        <button
          onClick={onRefresh}
          className="ml-auto text-amber-600 font-medium hover:text-amber-800 text-xs whitespace-nowrap"
        >
          Regenerate
        </button>
      )}
    </div>
  );
}
